/** Each segment of a secret path, the part of `skinseoul/{path}` after the prefix (1-4 segments). */
export const SECRET_SEGMENT_PATTERN = /^[a-z0-9][a-z0-9-]{0,62}$/;
export const SECRET_PATH_MAX_SEGMENTS = 4;
/** `skinseoul/system/*` holds server-only keys and is never managed here. */
export const SECRET_RESERVED_FIRST_SEGMENT = 'system';
export const SECRET_KEY_PATTERN = /^[A-Za-z_][A-Za-z0-9_]{0,127}$/;
export const SECRET_VALUE_MAX_BYTES = 4096;

export type SecretChangeOp = 'ADD' | 'UPDATE' | 'DELETE';
export type SecretRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CONFLICT' | 'APPLIED';

export interface SecretsMe {
  canManage: boolean;
  email: string | null;
}

export interface SecretSummary {
  path: string;
  name: string;
  fieldKeys: string[];
  updatedAt: string | null;
  pendingRequestCount: number;
}

export interface SecretField {
  key: string;
  value: string | null;
  restricted: boolean;
}

export interface SecretValues {
  versionId: string;
  fields: SecretField[];
}

export interface SecretPatchRequest {
  baseVersionId: string;
  set?: Record<string, string>;
  unset?: string[];
  restrict?: string[];
  unrestrict?: string[];
}

export interface SecretChangeRequestInput {
  op: SecretChangeOp;
  key: string;
  value?: string;
  reason: string;
}

export interface SecretRequestItem {
  requestId: string;
  path: string;
  op: SecretChangeOp;
  key: string;
  source: 'REQUEST' | 'DIRECT';
  status: SecretRequestStatus;
  requesterEmail: string | null;
  reason: string | null;
  createdAt: string;
  decidedBy: string | null;
  decidedAt: string | null;
  appliedVersionId: string | null;
}

export interface SecretAuditEvent {
  eventId: string;
  action: string;
  actorEmail: string | null;
  requestId: string | null;
  fieldKeys: string[];
  createdAt: string;
}

export interface SecretRequestValue {
  requestId: string;
  key: string;
  value: string | null;
}
